function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M456,144c13.255,0,24-10.745,24-24V24c0-13.255-10.745-24-24-24H24C10.745,0,0,10.745,0,24v96c0,13.255,10.745,24,24,24 h24v24H24c-13.255,0-24,10.745-24,24v96c0,13.255,10.745,24,24,24h24v24H24c-13.255,0-24,10.745-24,24v96 c0,13.255,10.745,24,24,24h432c13.255,0,24-10.745,24-24v-96c0-13.255-10.745-24-24-24h-24v-24h24c13.255,0,24-10.745,24-24v-96 c0-13.255-10.745-24-24-24h-24v-24H456z M456,352c4.418,0,8,3.582,8,8v96c0,4.418-3.582,8-8,8H24c-4.418,0-8-3.582-8-8v-96 c0-4.418,3.582-8,8-8H456z M64,336v-24h16v24H64z M96,336v-24h288v24H96z M400,336v-24h16v24H400z M456,184c4.418,0,8,3.582,8,8 v96c0,4.418-3.582,8-8,8H24c-4.418,0-8-3.582-8-8v-96c0-4.418,3.582-8,8-8H456z M64,168v-24h16v24H64z M96,168v-24h288v24H96z  M400,168v-24h16v24H400z M24,128c-4.418,0-8-3.582-8-8V24c0-4.418,3.582-8,8-8h432c4.418,0,8,3.582,8,8v96c0,4.418-3.582,8-8,8 H24z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,64H94.528C90.11,51.503,76.397,44.954,63.901,49.373S44.855,67.503,49.273,80s18.131,19.046,30.627,14.627 C86.735,92.211,92.112,86.835,94.528,80H256c4.418,0,8-3.582,8-8S260.418,64,256,64z M72,80c-4.418,0-8-3.582-8-8s3.582-8,8-8 s8,3.582,8,8S76.418,80,72,80z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 32,
  width: 16,
  height: 16
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 32,
  width: 16,
  height: 16
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 32,
  width: 16,
  height: 16
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 32,
  width: 16,
  height: 16
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 32,
  width: 16,
  height: 16
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 64,
  width: 16,
  height: 16
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 64,
  width: 16,
  height: 16
})));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 64,
  width: 16,
  height: 16
})));

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 64,
  width: 16,
  height: 16
})));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 64,
  width: 16,
  height: 16
})));

var _ref14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 96,
  width: 16,
  height: 16
})));

var _ref15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 96,
  width: 16,
  height: 16
})));

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 96,
  width: 16,
  height: 16
})));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 96,
  width: 16,
  height: 16
})));

var _ref18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 96,
  width: 16,
  height: 16
})));

var _ref19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,232H94.528c-4.418-12.497-18.131-19.046-30.627-14.627S44.855,235.503,49.273,248s18.131,19.046,30.627,14.627 c6.835-2.416,12.211-7.793,14.627-14.627H256c4.418,0,8-3.582,8-8S260.418,232,256,232z M72,248c-4.418,0-8-3.582-8-8s3.582-8,8-8 s8,3.582,8,8S76.418,248,72,248z"
})));

var _ref20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 200,
  width: 16,
  height: 16
})));

var _ref21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 200,
  width: 16,
  height: 16
})));

var _ref22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 200,
  width: 16,
  height: 16
})));

var _ref23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 200,
  width: 16,
  height: 16
})));

var _ref24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 200,
  width: 16,
  height: 16
})));

var _ref25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 232,
  width: 16,
  height: 16
})));

var _ref26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 232,
  width: 16,
  height: 16
})));

var _ref27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 232,
  width: 16,
  height: 16
})));

var _ref28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 232,
  width: 16,
  height: 16
})));

var _ref29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 232,
  width: 16,
  height: 16
})));

var _ref30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 264,
  width: 16,
  height: 16
})));

var _ref31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 264,
  width: 16,
  height: 16
})));

var _ref32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 264,
  width: 16,
  height: 16
})));

var _ref33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 264,
  width: 16,
  height: 16
})));

var _ref34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 264,
  width: 16,
  height: 16
})));

var _ref35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,400H94.528c-4.418-12.497-18.131-19.046-30.627-14.627S44.855,403.503,49.273,416s18.131,19.046,30.627,14.627 c6.835-2.416,12.211-7.793,14.627-14.627H256c4.418,0,8-3.582,8-8S260.418,400,256,400z M72,416c-4.418,0-8-3.582-8-8s3.582-8,8-8 s8,3.582,8,8S76.418,416,72,416z"
})));

var _ref36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 368,
  width: 16,
  height: 16
})));

var _ref37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 368,
  width: 16,
  height: 16
})));

var _ref38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 368,
  width: 16,
  height: 16
})));

var _ref39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 368,
  width: 16,
  height: 16
})));

var _ref40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 368,
  width: 16,
  height: 16
})));

var _ref41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 400,
  width: 16,
  height: 16
})));

var _ref42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 400,
  width: 16,
  height: 16
})));

var _ref43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 400,
  width: 16,
  height: 16
})));

var _ref44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 400,
  width: 16,
  height: 16
})));

var _ref45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 400,
  width: 16,
  height: 16
})));

var _ref46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 352,
  y: 432,
  width: 16,
  height: 16
})));

var _ref47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 384,
  y: 432,
  width: 16,
  height: 16
})));

var _ref48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 416,
  y: 432,
  width: 16,
  height: 16
})));

var _ref49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 432,
  width: 16,
  height: 16
})));

var _ref50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 288,
  y: 432,
  width: 16,
  height: 16
})));

var _ref51 = /*#__PURE__*/React.createElement("g", null);

var _ref52 = /*#__PURE__*/React.createElement("g", null);

var _ref53 = /*#__PURE__*/React.createElement("g", null);

var _ref54 = /*#__PURE__*/React.createElement("g", null);

var _ref55 = /*#__PURE__*/React.createElement("g", null);

var _ref56 = /*#__PURE__*/React.createElement("g", null);

var _ref57 = /*#__PURE__*/React.createElement("g", null);

var _ref58 = /*#__PURE__*/React.createElement("g", null);

var _ref59 = /*#__PURE__*/React.createElement("g", null);

var _ref60 = /*#__PURE__*/React.createElement("g", null);

var _ref61 = /*#__PURE__*/React.createElement("g", null);

var _ref62 = /*#__PURE__*/React.createElement("g", null);

var _ref63 = /*#__PURE__*/React.createElement("g", null);

var _ref64 = /*#__PURE__*/React.createElement("g", null);

var _ref65 = /*#__PURE__*/React.createElement("g", null);

function SvgServer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.38d01ae6.svg";
export { ForwardRef as ReactComponent };